import React from 'react';
import { Box, Container } from '@mui/material';
import UnifiedNavigation from '../UnifiedNavigation';
import UnifiedBreadcrumbs from '../Breadcrumbs';

const MainLayout = ({ children, maxWidth = 'xl', disablePadding = false }) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <UnifiedNavigation />
      <UnifiedBreadcrumbs />
      
      <Box component="main" sx={{ flexGrow: 1, backgroundColor: 'background.default' }}>
        {disablePadding ? (
          children
        ) : (
          <Container maxWidth={maxWidth} sx={{ py: 3 }}>
            {children}
          </Container>
        )}
      </Box>
    </Box>
  );
};

export default MainLayout;